import _asyncToGenerator from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-63aac5ec"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "tip"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 为 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索");

const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = {
  key: 0,
  class: "desc"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("保存");

import { ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { trainingCollectionList, trainingCollectionBindings, trainingAssignCollections } from '@/request';
export default {
  name: 'AssignCourseCollectionModal',
  props: {
    modelValue: Boolean,
    row: {
      type: Object,
      default: null
    }
  },
  emits: ['update:modelValue', 'success'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = ref(false);
    const loading = ref(false);
    const saving = ref(false);
    const keyword = ref('');
    const collections = ref([]);
    const selectedIds = ref([]);
    watch(() => props.modelValue, val => {
      visible.value = val;

      if (val) {
        keyword.value = '';
        selectedIds.value = [];
        collections.value = [];
        openLoad();
      }
    });
    watch(visible, val => {
      if (val !== props.modelValue) {
        emit('update:modelValue', val);
      }
    });

    function openLoad() {
      return _openLoad.apply(this, arguments);
    }

    function _openLoad() {
      _openLoad = _asyncToGenerator(function* () {
        loading.value = true;

        try {
          yield Promise.all([loadCollections(), loadBindings()]);
        } finally {
          loading.value = false;
        }
      });
      return _openLoad.apply(this, arguments);
    }

    function loadCollections() {
      return _loadCollections.apply(this, arguments);
    }

    function _loadCollections() {
      _loadCollections = _asyncToGenerator(function* () {
        const res = yield trainingCollectionList({
          keyword: keyword.value || undefined,
          page: 1,
          pageSize: 100
        });

        if (!res.success) {
          ElMessage.error(res.msg || '加载合集失败');
          collections.value = [];
          return;
        }

        const list = res.data || [];
        collections.value = Array.isArray(list) ? list : [];
      });
      return _loadCollections.apply(this, arguments);
    }

    function loadBindings() {
      return _loadBindings.apply(this, arguments);
    }

    function _loadBindings() {
      _loadBindings = _asyncToGenerator(function* () {
        var _props$row3;

        if (!((_props$row3 = props.row) !== null && _props$row3 !== void 0 && _props$row3.linkPhone)) {
          return;
        }

        const res = yield trainingCollectionBindings({
          linkPhone: props.row.linkPhone,
          supAccountId: props.row.supAccountId
        });

        if (!res.success) {
          ElMessage.error(res.msg || '加载已分配合集失败');
          return;
        }

        const data = res.data || {};
        selectedIds.value = Array.isArray(data.collectionIds) ? data.collectionIds.map(id => Number(id)) : [];
      });
      return _loadBindings.apply(this, arguments);
    }

    function save() {
      return _save.apply(this, arguments);
    }

    function _save() {
      _save = _asyncToGenerator(function* () {
        var _props$row4;

        if (!((_props$row4 = props.row) !== null && _props$row4 !== void 0 && _props$row4.linkPhone)) {
          ElMessage.warning('手机号无效');
          return;
        }

        saving.value = true;

        try {
          const res = yield trainingAssignCollections({
            supAccountId: props.row.supAccountId,
            linkPhone: props.row.linkPhone,
            linkMan: props.row.linkMan,
            collectionIds: selectedIds.value
          });

          if (!res.success) {
            ElMessage.error(res.msg || '保存失败');
            return;
          }

          ElMessage.success('绑定成功');
          visible.value = false;
          emit('success');
        } finally {
          saving.value = false;
        }
      });
      return _save.apply(this, arguments);
    }

    function onClosed() {
      keyword.value = '';
      collections.value = [];
      selectedIds.value = [];
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_empty = _resolveComponent("el-empty");

      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "绑定合集管理员",
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => visible.value = $event),
        width: "560px",
        "destroy-on-close": "",
        onClosed: onClosed
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: saving.value,
          onClick: save
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => {
          var _props$row, _props$row2;

          return [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("b", null, _toDisplayString(((_props$row = __props.row) === null || _props$row === void 0 ? void 0 : _props$row.linkMan) || '-'), 1), _createTextVNode("（" + _toDisplayString(((_props$row2 = __props.row) === null || _props$row2 === void 0 ? void 0 : _props$row2.linkPhone) || '-') + "）绑定合集管理员 ", 1)]), _createVNode(_component_el_input, {
            modelValue: keyword.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => keyword.value = $event),
            clearable: "",
            placeholder: "搜索合集名称",
            class: "search",
            onKeyup: _withKeys(loadCollections, ["enter"])
          }, {
            append: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: loadCollections
            }, {
              default: _withCtx(() => [_hoisted_3]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue", "onKeyup"]), _withDirectives((_openBlock(), _createBlock(_component_el_checkbox_group, {
            modelValue: selectedIds.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectedIds.value = $event),
            class: "list"
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collections.value, item => {
              return _openBlock(), _createBlock(_component_el_checkbox, {
                key: item.collectionId,
                label: item.collectionId,
                class: "item"
              }, {
                default: _withCtx(() => [_createElementVNode("span", _hoisted_4, _toDisplayString(item.name), 1), item.description ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.description), 1)) : _createCommentVNode("", true)]),
                _: 2
              }, 1032, ["label"]);
            }), 128)), !loading.value && !collections.value.length ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "暂无可绑定合集"
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["modelValue"])), [[_directive_loading, loading.value]])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};